import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const notifications = ['Mateo de Buenos Aires acaba de comprar el Manual Prohibido de la Creatina', 'Lucía de Córdoba acaba de descargar el pack completo', 'Santiago de Mendoza acaba de acceder al manual', 'Valentina de Santa Fe acaba de obtener el manual completo', 'Benjamín de Tucumán acaba de comprar el Manual Prohibido', 'Sofía de Salta acaba de obtener el pack completo', 'Thiago de Entre Ríos acaba de acceder al manual', 'Martina de Neuquén acaba de comprar el Manual Prohibido', 'Felipe de Chaco acaba de obtener el manual completo', 'Emma de Misiones acaba de descargar el pack completo', 'Juan de San Juan acaba de comprar el Manual Prohibido de la Creatina', 'Catalina de Jujuy acaba de acceder al manual'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(notifications[0]);
  useEffect(() => {
    const showNotification = () => {
      const randomMessage = notifications[Math.floor(Math.random() * notifications.length)];
      setCurrentMessage(randomMessage);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 15000 + 15000);
    setTimeout(showNotification, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-230">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -50
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-231">
          <div className="bg-[#132A44] border border-[#2F6BFF]/30 rounded-lg shadow-2xl p-4 flex items-start gap-3" data-id="element-232">
            <div className="flex-shrink-0" data-id="element-233">
              <CheckCircleIcon className="w-6 h-6 text-green-400" data-id="element-234" />
            </div>
            <div className="flex-1" data-id="element-235">
              <p className="text-sm text-[#F2F4F8] leading-relaxed" data-id="element-236">
                {currentMessage}
              </p>
              <p className="text-xs text-[#7EC8FF] mt-1" data-id="element-237">Hace unos momentos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}